// src/com/veh_banning/VehBanningDict.js
// DbdbTap 2024-10-02 10:16:23
import { TableColumnType } from "../../value/AppConst";
import ValueMisc from "../../value/ValueMisc";

/* const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    vehInfoSeq : {
		id: 'vehInfoSeq', label: 'vehInfoSeq',
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(11)
    comId : {
		id: 'comId', label: 'comId',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 10)},
	}, // varchar(10)
    vehDcCd : {
		id: 'vehDcCd', label: 'vehDcCd',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '3자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 3)},
	}, // varchar(3)
    vehDcName : {
		id: 'vehDcName', label: 'vehDcName',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    comName : {
		id: 'comName', label: 'comName',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '30자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 30)},
	}, // varchar(30)
    vehPlates : {
		id: 'vehPlates', label: 'vehPlates',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    driverName : {
		id: 'driverName', label: 'driverName',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '200자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 200)},
	}, // varchar(200)
    driverMobile : {
		id: 'driverMobile', label: 'driverMobile',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '200자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 200)},
	}, // varchar(200)
    useCvo : {
		id: 'useCvo', label: 'useCvo',
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(1)
    useCvoLabel : {
		id: 'useCvoLabel', label: 'useCvoLabel',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '4자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 4)},
	}, // varchar(4)
    dcCd : {
		id: 'dcCd', label: 'dcCd',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '3자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 3)},
	}, // varchar(3)
    dcName : {
		id: 'dcName', label: 'dcName',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    vehBanFlag : {
		id: 'vehBanFlag', label: 'vehBanFlag',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
		trueValue: 'Y', falseValue: 'N',
	}, // enum('Y','N')
    vehBanLabel : {
		id: 'vehBanLabel', label: 'vehBanLabel',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '4자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 4)},
	}, // varchar(4)
    vehBanPeriod : {
		id: 'vehBanPeriod', label: 'vehBanPeriod',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '21자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 21)},
	}, // varchar(21)
    vehBanLastingFlag : {
		id: 'vehBanLastingFlag', label: 'vehBanLastingFlag',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
		trueValue: 'Y', falseValue: 'N',
	}, // enum('N','Y')
    vehBanStartTime : {
		id: 'vehBanStartTime', label: 'vehBanStartTime',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // timestamp
    vehBanEndTime : {
		id: 'vehBanEndTime', label: 'vehBanEndTime',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // datetime 
    vehBanDays : {
		id: 'vehBanDays', label: 'vehBanDays',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(3)
    regUserName : {
		id: 'regUserName', label: 'regUserName',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '200자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 200)},
	}, // varchar(200)
    
}; */

/**
 * VEH_BANNING React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-10-02 10:16:23 using DbdbTap
 */
export const VehBanningDictionary = {
    // inputMap: Dict,
    errorTitle: {
        Get: '배차금지정보 조회 오류',
        GetNotBanned: '배차금지제외차량 조회 오류',
    },
    tableProps: {
        tableId: 'vehBanningTable',
        uniqueKey: 'vehInfoSeq',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            /*
            {dataKey: 'labelNumVehBanning', width: 100, numeric: true, label: 'No'},
            {dataKey: 'veh_dc_name', width: 150,numeric: false, label: '소속DC'},
            {dataKey: 'com_name', width: 125,numeric: false, label: '운송사'},
            {dataKey: 'veh_plates', width: 150,numeric: false, label: '차량번호'},
            {dataKey: 'driver_name',width: 120, numeric: false, label: '기사명'},
            {dataKey: 'driver_mobile', width: 100,numeric: false, label: '전화번호'},
            {dataKey: 'cvo_yn_label',width: 125, numeric: false, label: '위치추적'},
            {dataKey: 'dc_name',width: 125, numeric: false, label: '등록센터'},
            {dataKey: 'veh_ban_label',width: 125, numeric: false, label: '등록구분'},
            {dataKey: 'veh_ban_period',width: 125, numeric: false, label: '금지기간'},
            {dataKey: 'reg_date',width: 125, numeric: false, label: '등록일'},
            {dataKey: 'user_name',width: 125, numeric: false, label: '등록자'},
            */
            //print using getTableColumnOption(c,t,i)
            // { id: 'vehInfoSeq', label: Dict.vehInfoSeq.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'vehDcName', label: '소속DC', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comName', label: '운송사', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'comId', label: Dict.comId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'vehDcCd', label: Dict.vehDcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehPlates', label: '차량번호', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'driverName', label: '기사명', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'driverMobile', label: '전화번호', width: 120, show: true, privacy:true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'useCvo', label: Dict.useCvo.label, width: 120, show: true, option:{align: 'right', print:(r,i,v)=>v?'가입':'미가입'} },
            { id: 'useCvoLabel', label: '위치추적', width: 70, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            //{ id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcName', label: '등록센터', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            // { id: 'vehBanFlag', label: Dict.vehBanFlag.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehBanLabel', label: '등록구분', width: 80, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'vehBanPeriod', label: '금지기간', width: 180, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            //{ id: 'vehBanLastingFlag', label: Dict.vehBanLastingFlag.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'vehBanStartTime', label: Dict.vehBanStartTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            //{ id: 'vehBanEndTime', label: Dict.vehBanEndTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            //{ id: 'vehBanDays', label: Dict.vehBanDays.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'regDate', label: "등록일", width: 120, show: true, option:{align: 'center', print:(r,i,v)=>ValueMisc.substr(v,0,16)} },
            //{ id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regUserName', label: '등록자', width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
};
